<mat-card>
  <mat-card-header>
    <mat-card-title>{{fiberNid.storeNumber}} Fiber NID
      @if (fiberNid.imageUrl != null) {
        <span id="nid-image-link">
          <a target=”_blank” href="{{fiberNid.imageUrl}}"><mat-icon>image</mat-icon></a>
        </span>
      }
    </mat-card-title>

  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    <!-- <span *ngIf="circuit.loss == 0" id="network-health-badge-green">
    <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
  </span> -->

  <!-- <span *ngIf="fiberNid.imageUrl == null" id="nid-image-link">
  <a target=”_blank” href="{{fiberNid.imageUrl}}"><mat-icon>image</mat-icon></a>
</span> -->
@if (fiberNid.description != null) {
  <div>
    <p><b>Description:</b></p> <p>{{fiberNid.description}}</p>
  </div>
}
@if (fiberNid.description == null) {
  <div>
    <p><b>Location Unknown</b></p>
  </div>
}
@if (fiberNid.localLoop != null) {
  <div>
    <p><b>Local Loop:</b></p> <p>{{fiberNid.localLoop}}</p>
  </div>
}
@if (fiberNid.commitRate != null) {
  <div>
    <p><b>Commit Rate:</b></p> <p>{{fiberNid.commitRate / 1000}} Mbps</p>
  </div>
}
<!-- <p><b>Location:</b> {{fiberNid.location}}</p>
<p><b>Manufacturer:</b> {{fiberNid.manufacturer}}</p>
<p><b>Model:</b> {{fiberNid.model}}</p> -->
<!-- <span *ngIf="circuit.loss != 0" id="network-health-badge-red">
<mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
</span> -->

<!-- <p><b>IP:</b> {{circuit.serverIp}}</p> -->

<!-- <p><b>Jitter:</b> {{circuit.jitter}}</p>
<p><b>Packet Loss:</b> {{circuit.loss}}</p>
<p><b>Max Latency:</b> {{circuit.maxLatency}}</p>
<p><b>Min Latency:</b> {{circuit.minLatency}}</p>
<p><b>Average Latency:</b> {{circuit.avgLatency}}</p> -->
</mat-card-content>
</mat-card>